import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ValueSection } from './components/ValueSection';
import { GamesSection } from './components/GamesSection';
import { ServicesSection } from './components/ServicesSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-abyss text-gray-300 selection:bg-mystic-500 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <ValueSection data-id="element-5" />
        <GamesSection data-id="element-6" />
        <ServicesSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}